<div fxLayout="column" fxLayoutAlign="center center" style="max-width: 700px !important;">

    <div class="h1-confirmar" [class.background-green]="estiloGreen">
        <h1 matDialogTitle [class.h1-title]="estiloGreen">{{confirmTitle}}</h1>
        <div *ngIf="estiloGreen && exibeIconCancel" style="cursor: pointer; margin-top: 5px;"><mat-icon (click)="dialogRef.close(false)">close</mat-icon></div>
    </div>

    <div [class.padding-div]="estiloGreen">
        <div style="max-width: 700px !important;" class="confirm-message" >
            <span mat-dialog-content [class.span-dialog]="estiloGreen">{{ confirmMessage }}</span>
        </div>
    
        <form *ngIf="_data?.nomeCampos && _data?.nomeCampos.length > 0" [formGroup]="confirmDeleteForm" 
            fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" style="width: 100%; margin-top: 15px;">
                                    
            <mat-form-field  *ngIf="motivoCancelamento != '' " appearance="outline" floatLabel="always" fxFlex="100" fxFlex.gt-sm="100">                                                                                
                <mat-label>{{motivoCancelamento}}</mat-label>
                <textarea matInput formControlName="motivoCancelamento" [placeholder]="motivoCancelamento" rows="2" required></textarea>
            </mat-form-field>
    
        </form>
            
        <div mat-dialog-actions class="pt-24" style="display: flex; align-items: center; justify-content: center;">
            <button *ngIf="_data?.nomeCampos == undefined || _data?.nomeCampos == null" mat-raised-button class="color-green mr-16" (click)="dialogRef.close(true)">{{textBtnConfirm}}</button>
            <button *ngIf="_data?.nomeCampos && _data?.nomeCampos.length > 0" mat-raised-button class="color-green mr-16" (click)="fecharModalMotivoCancelamento()">{{textBtnConfirm}}</button>
            <button *ngIf="!naoExibeCancel" mat-button (click)="dialogRef.close(false)">{{textBtnCancel}}</button>
        </div>
    </div>
    
        
</div>


